export default "__VITE_ASSET__D69y3GNK__"